import { Avatar as AntAvatar, Space } from 'antd';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { ProjectDuration } from 'components/molecules/project-duration';
import { ProjectName } from 'components/organisms/projects/project-sidebar/detail-row';
import { ProjectPlanFilter, useProjectDetail } from 'data/projects/hooks';
import { useAccount } from 'hooks/use-account';

const Label = styled.span`
  margin: 0 var(--spacing-02);
`;

export const PDFInfo: FC<{ projectId: ProjectId; filter: ProjectPlanFilter }> =
  ({ projectId, filter }) => {
    const { company } = useAccount();
    const { data: project } = useProjectDetail(projectId);

    return (
      <Space direction="vertical" size="large">
        {project ? (
          <>
            <AntAvatar.Group>
              <Avatar src={project.customer.companyLogoUrl} size="large" />
              <Avatar src={company.companyLogoUrl} size="large" />
            </AntAvatar.Group>
            <div>
              <ProjectName>{project.projectName}</ProjectName>
              <div>
                {project.startDate || project.dueDate ? (
                  <ProjectDuration
                    startDate={
                      project.startDate ? moment(project.startDate) : null
                    }
                    dueDate={project.dueDate ? moment(project.dueDate) : null}
                    showDuration
                  />
                ) : null}
              </div>
            </div>
            <div>
              <Label>
                <FormattedMessage
                  id="export.project_owner"
                  values={{ email: project.projectOwner.emailId }}
                />
              </Label>
              <Label>
                <FormattedMessage
                  id="export.view"
                  values={{ viewLabel: filter.primary.label }}
                />
              </Label>
              <Label>
                <FormattedMessage
                  id="export.responsible"
                  values={{ responsibleLabel: filter.secondary.label }}
                />
              </Label>
            </div>
          </>
        ) : null}
      </Space>
    );
  };
